import { getFirstDayOfCurrentMonth } from './helpers';

export const DEFAULT_PAYOUT_DATE = getFirstDayOfCurrentMonth();
